export default __webpack_public_path__ + "static/media/egg-step1.c7337ada.jpg";